import { CSSProperties } from 'react';

interface IDiv {
  children: React.ReactNode;
  classes?: string;
  styles?: CSSProperties;
}

export const Div = ({ children, classes, styles, ...props }: IDiv) => (
  <div className={classes} style={styles} {...props}>
    {children}
  </div>
);
